import React from "react";
import { ArrowUp } from "lucide-react";
import { motionSafeScrollBehavior } from "@/lib/a11yPrefs";

// כפתור "חזרה למעלה" צף — דסקטופ בלבד (lg+). במובייל הכפתור הזה משולב בתוך סרגל
// הניווט התחתון (MobileBottomNav) ליד "עוד", כדי לא להתנגש בסרגל השמירה של המסמך.
export default function BackToTop() {
  const [visible, setVisible] = React.useState(false);

  React.useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 500);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const toTop = () => window.scrollTo({ top: 0, left: 0, behavior: motionSafeScrollBehavior() });

  return (
    <button
      type="button"
      onClick={toTop}
      aria-label="חזרה לראש העמוד"
      title="חזרה למעלה"
      tabIndex={visible ? 0 : -1}
      aria-hidden={!visible}
      className={`hidden lg:flex fixed left-5 bottom-6 z-30 print:hidden w-12 h-12 rounded-full gradient-primary text-white shadow-xl shadow-primary/30 items-center justify-center transition-all duration-300 hover:-translate-y-1 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/50 ${
        visible
          ? "opacity-100 translate-y-0 pointer-events-auto"
          : "opacity-0 translate-y-4 pointer-events-none"
      }`}
    >
      <ArrowUp className="w-6 h-6" />
    </button>
  );
}
